import { AuthService } from './../../services/auth.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { isPlatform } from '@ionic/angular';
import { CookieService } from 'ngx-cookie-service';
import { SubscriberLoginResp } from 'src/app/components/interface/Subscriber/SubscriberLoginResp';
import { RuntimeConfigService } from 'src/app/services/runtime-config.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(private authService: AuthService, private router: Router, private cookieService: CookieService, private runtimeConfigService: RuntimeConfigService) { }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    let isLoggedIn = false;
    let userType: 'subscriber' | 'companyUser' | 'blogUser' | null = null;
    let subscriberId = '';

    const isElectron = this.runtimeConfigService.isElectron;

    if (isPlatform('capacitor')) {
      const subscriber = await this.authService.getPreferenceSubscriberDetails();
      isLoggedIn = !!subscriber;
      if (subscriber) {
        userType = 'subscriber';
        subscriberId = subscriber.subscriberID?.toString() || '';
      }
    } else if(isElectron) {
      const subscriber = localStorage.getItem('subscriber') || sessionStorage.getItem('subscriber');
      if(subscriber) {
        isLoggedIn = true;
        userType = 'subscriber';
        subscriberId = localStorage.getItem('subscriberID') || sessionStorage.getItem('subscriberID');
      }
    } else {
      const subscriberString = sessionStorage.getItem('subscriber') || this.cookieService.get('subscriber');
      const blogUserString = sessionStorage.getItem('blogUser');
      const companyUserString = sessionStorage.getItem('companyUser');

      if (subscriberString) {
        isLoggedIn = true;
        userType = 'subscriber';
        subscriberId = sessionStorage.getItem('subscriberID') || this.cookieService.get('subscriberID');
      } else if (blogUserString) {
        isLoggedIn = true;
        userType = 'blogUser';
      } else if (companyUserString) {
        isLoggedIn = true;
        userType = 'companyUser';
      }
    }

    // Handle root route (landing page)
    if (state.url === '/') {
      if (isLoggedIn) {
        if (userType === 'subscriber') {
          await this.router.navigate(['view-company'], { queryParams: { subscriberID: subscriberId } });
          return false; // Prevent further route activation
        } else if (userType === 'companyUser') {
          await this.router.navigate(['admin/home']);
          return false;
        } else if (userType === 'blogUser') {
          await this.router.navigate(['view-blog']);
          return false;
        }
      }
      return true; // Allow access to the landing page
    }

    // Handle other routes (protected)
    if (isLoggedIn) {
      return true; // Allow access to protected routes
    } else {
      await this.router.navigate(['subscriber-login']);
      return false; // Redirect to login for unauthenticated users
    }
  }
}
